(function () {
  if (window.__bionetteInit) return;
  window.__bionetteInit = true;

  function initFadeIn() {
    var targets = document.querySelectorAll('.bionette__fade-in:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -100px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initFaq(root) {
    var items = (root || document).querySelectorAll('[data-bn-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-bn-faq-toggle]');
      if (!btn || btn.dataset.bnBound === '1') return;
      btn.dataset.bnBound = '1';
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initStickyBar(root) {
    var bars = (root || document).querySelectorAll('[data-bn-sticky-bar]');
    bars.forEach(function (bar) {
      if (bar.dataset.bnBound === '1') return;
      bar.dataset.bnBound = '1';
      var threshold = parseInt(bar.getAttribute('data-threshold') || '800', 10);
      function onScroll() {
        if (window.scrollY > threshold) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initTestimonialsScroll(root) {
    var sliders = (root || document).querySelectorAll('[data-bn-testimonials]');
    sliders.forEach(function (slider) {
      if (slider.dataset.bnBound === '1') return;
      slider.dataset.bnBound = '1';
      var prev = slider.querySelector('[data-bn-testi-prev]');
      var next = slider.querySelector('[data-bn-testi-next]');
      var track = slider.querySelector('[data-bn-testi-track]');
      if (!track) return;
      function step() {
        var card = track.querySelector('[data-bn-testi-card]');
        return card ? card.offsetWidth + 16 : 300;
      }
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  function initHowSlider(root) {
    var sliders = (root || document).querySelectorAll('[data-bn-how-slider]');
    sliders.forEach(function (slider) {
      if (slider.dataset.bnBound === '1') return;
      slider.dataset.bnBound = '1';
      var prev = slider.querySelector('[data-bn-how-prev]');
      var next = slider.querySelector('[data-bn-how-next]');
      var track = slider.querySelector('[data-bn-how-track]');
      if (!track) return;
      function step() {
        var row = track.querySelector('.bionette-how__row');
        return row ? row.offsetWidth + 12 : 300;
      }
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  function initVideoEmbedLazy(root) {
    var blocks = (root || document).querySelectorAll('[data-bn-video-embed-lazy]');
    blocks.forEach(function (block) {
      if (block.dataset.bnBound === '1') return;
      block.dataset.bnBound = '1';
      var play = block.querySelector('[data-bn-video-embed-play]');
      var poster = block.querySelector('[data-bn-video-embed-poster]');
      var target = block.querySelector('[data-bn-video-embed-iframe-root]');
      var tpl = block.querySelector('template[data-bn-video-embed-tpl]');
      if (!play || !poster || !target || !tpl) return;
      function activate() {
        if (block.dataset.bnVideoLoaded === '1') return;
        block.dataset.bnVideoLoaded = '1';
        target.appendChild(tpl.content.cloneNode(true));
        target.classList.add('bionette-video-embed__iframe-root--loaded');
        poster.setAttribute('hidden', '');
        tpl.remove();
      }
      play.addEventListener('click', function () {
        activate();
      });
    });
  }

  function initAll(root) {
    initFadeIn();
    initFaq(root);
    initStickyBar(root);
    initTestimonialsScroll(root);
    initHowSlider(root);
    initVideoEmbedLazy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { /* noop */ });
})();
